if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      
      // Check if this is a combined listing (has product url)
      this.isCombinedListing = false;
      const productUrls = this.querySelectorAll('[data-product-url]');
      productUrls.forEach(option => {
        if (option.dataset.productUrl !== null && option.dataset.productUrl !== '') {
          this.isCombinedListing = true;
        }
      });
    
      this.addToCartButton = document.getElementById('AddToCart');

      this.variantMetafields = JSON.parse(document.getElementById(`VariantMetafields-${this.dataset.section}`)?.textContent || '{}');
      
      this.lastVariantId = null;
      
      setTimeout(() => {
        this.updateArrivalAndPreOrderDate();
      }, 0);
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    formatDate(dateString) {
      if (!dateString) return null;
      const [year, month, day] = dateString.split('-');
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    updateArrivalAndPreOrderDate() {
      const arrivalDateElement = this.productWrapper.querySelector('#variant-arrival-date');
      if (arrivalDateElement && this.currentVariant) {
        const metafields = this.variantMetafields[this.currentVariant.id];
        const canSell = metafields?.can_sell === 'true';
        const isPreOrder = metafields?.pre_order === 'true';
        const isDemo = this.productWrapper.hasAttribute('data-product-is-demo');
        
        const isInventoryTracked = this.currentVariant.inventory_management === 'shopify';

        // Handle stock message display
        if (!isInventoryTracked) {
          arrivalDateElement.style.display = 'none';
        } else {
          if (isPreOrder && metafields?.arrival_date) {
              const arrivalDate = metafields.arrival_date;
              if (arrivalDate === "7 Days" || arrivalDate === "2 Days") {
                  arrivalDateElement.textContent = `This product will be available in ${arrivalDate}`;
                  arrivalDateElement.style.display = 'flex';
              } else if (arrivalDate && arrivalDate !== 'null' && arrivalDate !== '-') {
                  try {
                      const date = new Date(arrivalDate);
                      if (!isNaN(date.getTime())) {
                          const formattedDate = new Intl.DateTimeFormat('en-US', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                          }).format(date);
                          arrivalDateElement.textContent = `This product will be available on ${formattedDate}`;
                          arrivalDateElement.style.display = 'flex';
                      } else {
                        arrivalDateElement.textContent = metafields?.arrival_date
                        arrivalDateElement.style.display = 'flex';
                      }
                  } catch (e) {
                    arrivalDateElement.style.display = 'none';
                  }
              }
          } else {
              arrivalDateElement.style.display = 'none';
          }
        }

        // Update button state
        if (this.addToCartButton) {
            const buttonText = this.addToCartButton.querySelector('.single-add-to-cart-button--text');
            
            if (!isInventoryTracked) {
                // If inventory is not tracked, always show Add to Cart
                if (isDemo) {
                  buttonText.textContent = window.theme.variantStrings.addDemoToCart;
                  this.addToCartButton.disabled = false;
                  this.addToCartButton.classList.remove('sold-out');
                } else {
                  buttonText.textContent = window.theme.variantStrings.addToCart;
                  this.addToCartButton.disabled = false;
                  this.addToCartButton.classList.remove('sold-out');
                }

            } else {
                // Apply can_sell and pre_order rules only when inventory is tracked
                if (!canSell) {
                    buttonText.textContent = window.theme.variantStrings.soldOut;
                    this.addToCartButton.disabled = true;
                    this.addToCartButton.classList.add('sold-out');
                } else if (canSell && isPreOrder) {
                    buttonText.textContent = window.theme.variantStrings.preOrder;
                    this.addToCartButton.disabled = false;
                    this.addToCartButton.classList.remove('sold-out');
                } else if (canSell && isDemo) {
                    buttonText.textContent = window.theme.variantStrings.addDemoToCart;
                    this.addToCartButton.disabled = false;
                    this.addToCartButton.classList.remove('sold-out');
                } else {
                  if (this.currentVariant.available) {
                    buttonText.textContent = window.theme.variantStrings.addToCart;
                    this.addToCartButton.disabled = false;
                    this.addToCartButton.classList.remove('sold-out');
                  } else {
                    buttonText.textContent = window.theme.variantStrings.soldOut;
                    this.addToCartButton.disabled = true;
                    this.addToCartButton.classList.add('sold-out');
                  }
                }
            }
        }
      }
    }

    updateQuantityRules(isPreOrder) {
        const quantityInput = document.querySelector('quantity-selector input[type="number"]');
        if (!quantityInput) return;

        if (isPreOrder) {
            quantityInput.removeAttribute('max');
        } else if (this.currentVariant.inventory_management === 'shopify') {
            quantityInput.setAttribute('max', this.currentVariant.inventory_quantity.toString());
        }
    }
    
    onVariantChange(event) {
      // Get the product element and section ID
      const productElement = event.target.closest('.thb-product-detail');
      const sectionId = this.dataset.section;

      // Get the clicked option value element
      const optionValueElement = event.target;
      
      // Check if option has data-product-url (combined listings) or is empty (deferred variants)
      const hasProductUrl = optionValueElement.dataset.productUrl && optionValueElement.dataset.productUrl.trim() !== '';
      const oldProductUrl = this.dataset.url;
      const newProductUrl = optionValueElement.dataset.productUrl;

      if (hasProductUrl) {
        // Combined listings: Change product URL
        this.handleCombinedListings(event, productElement, sectionId, oldProductUrl, newProductUrl);
      } else {
        // Deferred variants: Change variant ID
        this.handleDeferredVariants(event, productElement, sectionId, optionValueElement);
      }
    }

// Handle combined listings (product URL change)
handleCombinedListings(event, productElement, sectionId, oldProductUrl, newProductUrl) {
  // Store the current selections BEFORE removing the element
  const currentOptions = [];
  const currentFieldsets = Array.from(this.querySelectorAll('fieldset'));
  currentFieldsets.forEach((fieldset) => {
    if (fieldset.querySelector('select')) {
      currentOptions.push(fieldset.querySelector('select').value);
    } else if (fieldset.querySelectorAll('input').length) {
      const checkedInput = fieldset.querySelector('input:checked');
      if (checkedInput) {
        currentOptions.push(checkedInput.value);
      }
    }
  });

  // Get only the COLORWAY option value (the one that was clicked)
  const clickedOptionValue = event.target.dataset.optionValueId;
  const params = clickedOptionValue ? `&option_values=${clickedOptionValue}` : '';

  // Fetch from the COMBINED LISTING with only the colorway option
  fetch(`${oldProductUrl}?section_id=${sectionId}${params}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      // Replace the old product section with the new product section
      const newProductSection = html.querySelector('.thb-product-detail');
      if (newProductSection && productElement) {
        productElement.parentNode.insertBefore(newProductSection, productElement);
        productElement.remove();

        // Get references to the new elements
        const newVariantSelects = newProductSection.querySelector('variant-selects');
        const newProductSlider = newProductSection.querySelector('.product-images');

        // CRITICAL: Restore the size/other options that were selected
        if (newVariantSelects && currentOptions.length > 1) {
          const newFieldsets = Array.from(newVariantSelects.querySelectorAll('fieldset'));
          
          // Skip the first option (colorway - already set) and restore the rest (size, etc.)
          for (let i = 1; i < currentOptions.length && i < newFieldsets.length; i++) {
            const optionValue = currentOptions[i];
            const fieldset = newFieldsets[i];
            
            if (fieldset.querySelector('select')) {
              const select = fieldset.querySelector('select');
              if (select) {
                select.value = optionValue;
              }
            } else if (fieldset.querySelectorAll('input').length) {
              const input = fieldset.querySelector(`input[value="${optionValue}"]`);
              if (input) {
                input.checked = true;
              }
            }
          }
        }

        // NOW initialize the variant-selects with the restored options
        if (newVariantSelects) {
          newVariantSelects.updateOptions();      // Reads the restored options
          newVariantSelects.updateMasterId();     // Finds the matching variant
          newVariantSelects.updateVariantInput(); // Updates the form input
          newVariantSelects.updateVariantText();  // Updates the display text
        }

        // Update the URL - keep the combined listing URL
        if (window.history && window.history.replaceState) {
          const combinedListingUrl = new URL(oldProductUrl, window.location.origin);
          
          // Get variant ID from the newly initialized variant-selects
          const newVariantId = newVariantSelects && newVariantSelects.currentVariant 
            ? newVariantSelects.currentVariant.id 
            : null;
          
          if (newVariantId) {
            combinedListingUrl.searchParams.set('variant', newVariantId);
          }
          
          window.history.replaceState({}, '', combinedListingUrl.toString());
        }

        // Focus the input for the last clicked option value
        const newInput = document.querySelector(`#${event.target.id}`);
        if (newInput) newInput.focus();

        // CRITICAL FIX: Reinitialize the product slider and update media
        setTimeout(() => {
          if (newProductSlider && typeof Flickity !== 'undefined') {
            const flkty = Flickity.data(newProductSlider);
            
            if (flkty) {
              flkty.destroy();
            }

            const productSliderElement = newProductSection.querySelector('product-slider');
            if (productSliderElement && productSliderElement.init) {
              productSliderElement.init();
            }
          }

          // Update the featured media to show the correct variant image
          if (newVariantSelects && newVariantSelects.currentVariant) {
            const currentVariant = newVariantSelects.currentVariant;
            
            if (currentVariant.featured_media) {
              const mediaId = `#Slide-${sectionId}-${currentVariant.featured_media.id}`;
              const thumbId = `#Thumb-${sectionId}-${currentVariant.featured_media.id}`;
              const slider = newProductSection.querySelector('.product-images');
              const thumbnails = newProductSection.querySelector('.product-thumbnail-container');
              
              if (slider) {
                const flkty = Flickity.data(slider);
                if (flkty) {
                  flkty.selectCell(mediaId);
                  
                  const activeMedia = slider.querySelector(mediaId);
                  if (activeMedia) {
                    slider.querySelectorAll('.product-images__slide').forEach(slide => {
                      slide.classList.remove('is-initial-selected');
                    });
                    activeMedia.classList.add('is-initial-selected');
                  }
                  
                  if (thumbnails) {
                    const activeThumb = thumbnails.querySelector(thumbId);
                    if (activeThumb) {
                      thumbnails.querySelectorAll('.product-thumbnail').forEach(thumb => {
                        thumb.classList.remove('is-initial-selected');
                      });
                      activeThumb.classList.add('is-initial-selected');
                    }
                  }
                }
              }
            }
          }

          // Trigger events
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
          window.dispatchEvent(new Event('resize'));
          
          dispatchCustomEvent('product:variant-change', {
            variant: newVariantSelects ? newVariantSelects.currentVariant : null,
            sectionId: sectionId
          });
          
        }, 100);
      }
    })
    .catch((error) => {
      console.error('Error updating product selection:', error);
      this.fallbackVariantChange();
    });
}
// Handle deferred variants (regular variant change)
handleDeferredVariants(event, productElement, sectionId, optionValueElement) {
  this.updateOptions();
  this.updateMasterId();
  this.toggleAddButton(true, '', false);
  this.updatePickupAvailability();
  this.removeErrorMessage();
  this.updateVariantText();
  this.setDisabled();

  if (!this.currentVariant) {
    this.toggleAddButton(true, '', true);
    this.setUnavailable();
  } else {
    this.updateMedia();
    if (this.updateUrl) {
      this.updateURL();
    }
    this.updateVariantInput();
    this.renderProductInfo();
  }

  this.updateOther();
  
  dispatchCustomEvent('product:variant-change', {
    variant: this.currentVariant,
    sectionId: this.dataset.section
  });

  this.lastVariantId = this.currentVariant ? this.currentVariant.id : null;
  this.updateArrivalAndPreOrderDate();
}
    // Fallback method for when fetch fails
    fallbackVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();
      
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });

      this.lastVariantId = this.currentVariant ? this.currentVariant.id : null;
      this.updateArrivalAndPreOrderDate();
    }

// Update product info from the fetched response
updateProductInfoFromResponse(html) {
  const sections = this.getSectionsToRender();

  sections.forEach((id) => {
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;

      const price = document.getElementById(id);
      const price_fixed = document.getElementById(id + '--sticky');

      if (price) price.classList.remove('visibility-hidden');
      if (price_fixed) price_fixed.classList.remove('visibility-hidden');
    }
  });

  // Update variant data if available
  const newVariantData = html.querySelector('script[type="application/json"]');
  if (newVariantData) {
    try {
      this.variantData = JSON.parse(newVariantData.textContent);
    } catch (e) {
      console.error('Error parsing new variant data:', e);
    }
  }

  // Update current variant and related elements
  this.updateOptions();
  this.updateMasterId();
  this.updateVariantText();
  this.setDisabled();
  
  // FIX: Add media update here to match old behavior
  if (this.currentVariant) {
    this.updateMedia();
    if (this.updateUrl) {
      this.updateURL();
    }
  }
  
  this.updateVariantInput();
  this.updateArrivalAndPreOrderDate();

  // Update button state
  if (this.currentVariant) {
    this.toggleAddButton(!this.currentVariant.available, this.currentVariant.available ? '' : window.theme.variantStrings.soldOut);
  }

  // Dispatch event
  dispatchCustomEvent('product:variant-change', {
    variant: this.currentVariant,
    sectionId: this.dataset.section
  });
}

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {


        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
    
      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
    
      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
    
        if (!submitButtonText) return;
    
        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
    
          // Let updateArrivalAndPreOrderDate handle the button text
          this.updateArrivalAndPreOrderDate();
        }
      });
    
      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                const optionElement = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
                if (optionElement && option) {
                  if (option.isUnavailable) {
                    optionElement.disabled = true;
                  } else {
                    optionElement.disabled = false;
                  }
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                // Add bounds checking to prevent undefined access
                if (fieldset_options && fieldset_options[input_i]) {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                }
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // For combined listings, use simplified logic
      if (this.isCombinedListing) {
        // Simplified logic: only disable options that have no available variants
        return variants.reduce((options, variant) => {
          Object.keys(options).forEach(index => {
            if (variant[index] === null) return;

            let entry = options[index].find(option => option.value === variant[index]);
            if (typeof entry === 'undefined') {
              entry = { value: variant[index], isUnavailable: !variant.available };
              options[index].push(entry);
            } else {
              // If any variant with this option is available, mark it as available
              if (variant.available) {
                entry.isUnavailable = false;
              }
            }
          });
          return options;
        }, { option1: [], option2: [], option3: [] });
      }

      // Original logic for standard products
      return variants.reduce((options, variant) => {
        Object.keys(options).forEach(index => {
          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);
          if (typeof entry === 'undefined') {
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });
        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
// --- SINGLE VARIANT ARRIVAL DATE SUPPORT -------------------------------
(function () {
  // Run only on product pages that do NOT have <variant-selects>
  const productWrapper = document.querySelector('.thb-product-detail');
  if (!productWrapper || document.querySelector('variant-selects')) return;

  // Try to resolve the section id used in your IDs like price-{{ section.id }}
  const guessSectionId = () => {
    // Preferred: data-section on wrapper (add once in Liquid if not present)
    if (productWrapper.dataset.section) return productWrapper.dataset.section;

    // Fallback: find an element with id="price-<sectionId>"
    const priceEl = Array.from(document.querySelectorAll('[id^="price-"]'))
      .find(el => el.id && el.id.indexOf('--sticky') === -1);
    if (priceEl) return priceEl.id.replace('price-', '');

    // Last resort: look for a product form id="product-form-<sectionId>"
    const formEl = document.querySelector('[id^="product-form-"]');
    if (formEl) return formEl.id.replace('product-form-', '');

    return null;
  };

  const sectionId = guessSectionId();
  if (!sectionId) return;

  // Elements
  const arrivalDateElement = productWrapper.querySelector('#variant-arrival-date');
  const addToCartButton = document.getElementById('AddToCart');
  const buttonText = addToCartButton?.querySelector('.single-add-to-cart-button--text');

  if (!arrivalDateElement) return; // nothing to render into

  // Get current variant id from the hidden input on the form
  const variantIdInput = document.querySelector(`#product-form-${sectionId} [name="id"]`);
  const currentVariantId = variantIdInput?.value;
  if (!currentVariantId) return;

  // Get the same VariantMetafields JSON your theme already renders
  let variantMetafields = {};
  try {
    const jsonEl = document.getElementById(`VariantMetafields-${sectionId}`);
    if (jsonEl && jsonEl.textContent) {
      variantMetafields = JSON.parse(jsonEl.textContent) || {};
    }
  } catch (e) {
    // if parsing fails, fail silently
  }

  const metafields = variantMetafields[currentVariantId] || {};
  const isPreOrder = metafields?.pre_order === 'true';
  const arrivalRaw = metafields?.arrival_date;

  // Optional: inventory tracking + demo flags if you expose them in HTML (see step 2)
  const inventoryManagement = productWrapper.getAttribute('data-variant-inventory-management'); // 'shopify' or ''
  const isInventoryTracked = inventoryManagement === 'shopify' || inventoryManagement === 'Shopify';
  const isDemo = productWrapper.hasAttribute('data-product-is-demo');

  // RENDER ARRIVAL DATE (mirrors your existing logic)
  const showArrivalText = () => {
    if (!isPreOrder || !arrivalRaw) {
      arrivalDateElement.style.display = 'none';
      return;
    }

    // If you must hide when inventory isn't tracked, keep this guard:
    if (inventoryManagement && !isInventoryTracked) {
      arrivalDateElement.style.display = 'none';
      return;
    }

    if (arrivalRaw === '7 Days' || arrivalRaw === '2 Days') {
      arrivalDateElement.textContent = `This product will be available in ${arrivalRaw}`;
      arrivalDateElement.style.display = 'flex';
      return;
    }

    // Try parsing as a date, otherwise show the raw string
    try {
      const date = new Date(arrivalRaw);
      if (!isNaN(date.getTime())) {
        const formatted = new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }).format(date);
        arrivalDateElement.textContent = `This product will be available on ${formatted}`;
        arrivalDateElement.style.display = 'flex';
      } else {
        arrivalDateElement.textContent = arrivalRaw;
        arrivalDateElement.style.display = 'flex';
      }
    } catch {
      arrivalDateElement.style.display = 'none';
    }
  };

  // OPTIONAL: button text harmonized with your variant-selects logic
  const updateButtonState = () => {
    if (!addToCartButton || !buttonText) return;

    // If you don't know can_sell or available on single-variant pages,
    // you can still swap to "Pre-order" when pre_order is true.
    if (isPreOrder) {
      buttonText.textContent = window.theme?.variantStrings?.preOrder || 'Pre-order';
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('sold-out');
    } else if (isDemo) {
      buttonText.textContent = window.theme?.variantStrings?.addDemoToCart || 'Add to Cart';
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('sold-out');
    } else {
      // fall back to normal Add to Cart
      buttonText.textContent = window.theme?.variantStrings?.addToCart || 'Add to Cart';
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('sold-out');
    }
  };

  showArrivalText();
  updateButtonState();
})();

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;
        this.hideErrors = this.dataset.hideErrors === "true";

        this.setupPreOrderProperty();
      }

      // Keeps a hidden properties[_pre-order] input inside the product form
      // in sync with the selected variant. Aftersell's cart reads the form
      // fields directly when it adds to cart, so the property is sent no
      // matter which script handles the submit.
      setupPreOrderProperty() {
        if (!this.form) return;

        let input = this.form.querySelector('[data-preorder-prop]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_pre-order]';
          input.value = 'true';
          input.disabled = true;
          input.setAttribute('data-preorder-prop', '');
          this.form.appendChild(input);
        }

        const sync = () => {
          const idInput = this.form.querySelector('[name="id"]');
          input.disabled = !this.isPreOrderVariant(idInput ? idInput.value : null);
        };

        if (!this.form.dataset.preorderSyncBound) {
          this.form.dataset.preorderSyncBound = 'true';
          this.form.addEventListener('change', sync);
          this.form.addEventListener('submit', sync, true);
          document.addEventListener('product:variant-change', () => setTimeout(sync, 0));
        }

        sync();
      }

      // Looks up the pre_order flag for a variant.
      // Works on multi-variant products (via <variant-selects>) and on
      // single-variant products, where <variant-selects> is not rendered,
      // by reading the VariantMetafields JSON for this section directly.
      isPreOrderVariant(variantId) {
        if (!variantId) return false;

        let metafields = null;

        const variantSelects =
          document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`) ||
          document.querySelector('variant-selects');

        if (variantSelects && variantSelects.variantMetafields && variantSelects.variantMetafields[variantId]) {
          metafields = variantSelects.variantMetafields;
        } else {
          const jsonEl = document.getElementById(`VariantMetafields-${this.dataset.section}`);
          if (jsonEl && jsonEl.textContent) {
            try {
              metafields = JSON.parse(jsonEl.textContent) || {};
            } catch (e) {
              metafields = null;
            }
          }
        }

        return !!(metafields && metafields[variantId] && String(metafields[variantId].pre_order) === 'true');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form.reportValidity()) {
          return;
        }

        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button"
        );

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };

        let formData = new FormData(this.form);

        const variantId = formData.get('id');
        const isPreOrder = this.isPreOrderVariant(variantId);

        if (isPreOrder && !formData.has('properties[_pre-order]')) {
          formData.append('properties[_pre-order]', 'true');
        }

        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;


        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.updateCartContents(); // Update cart contents
              return;
            }
            
            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(
              "An error occurred while updating the cart."
            );
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });

            // Delay before opening the cart drawer to ensure UI update
            setTimeout(() => {
              this.openCartDrawer();
            }, 500); // Adjust the delay as needed
          });
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }

      updateCartContents() {
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            fetch(`${window.location.pathname}?section_id=${section.section}`)
              .then((res) => res.text())
              .then((html) => {
                const newContent = new DOMParser()
                  .parseFromString(html, "text/html")
                  .querySelector(section.selector);
                if (newContent) {
                  element.innerHTML = newContent.innerHTML;

                  // Update cart item count specifically
                  this.updateCartItemCount();
                }
              });
          }
        });
      }

      renderContents(parsedState) {
        // Update cart sections
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        // Update custom header cart count (te-header-icon__count)
        const customCartCount = document.querySelector('.te-header-icon__count');
        if (customCartCount && parsedState.item_count !== undefined) {
          customCartCount.textContent = parsedState.item_count;
        } else if (customCartCount && parsedState.items) {
          // Calculate total quantity from items
          const totalQty = parsedState.items.reduce((sum, item) => sum + item.quantity, 0);
          customCartCount.textContent = totalQty;
        }

        // Update CartDrawer and Cart instances
        if (typeof CartDrawer !== "undefined") {
          const cartDrawerInstance = new CartDrawer();
          if (cartDrawerInstance.renderContents) {
            cartDrawerInstance.renderContents(parsedState); // Ensure this updates the cart drawer correctly
          }
        }
        if (typeof Cart !== "undefined") {
          const cartInstance = new Cart();
          if (cartInstance.renderContents) {
            cartInstance.renderContents(parsedState); // Ensure this updates the cart
          }
        }
      }

      openCartDrawer() {
        let product_drawer = document.getElementById("Product-Drawer"),
          search_drawer = document.getElementById("Search-Drawer");

        if (search_drawer && search_drawer.classList.contains("active")) {
          search_drawer.classList.remove("active");
        }
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");
          this.body.classList.remove("open-cc--product");
          if (document.getElementById("Cart-Drawer")) {
            this.body.classList.add("open-cc");
            document.getElementById("Cart-Drawer").classList.add("active");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          this.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
          dispatchCustomEvent("cart-drawer:open");
        }
      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }

    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }

    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}